if (!customElements.get('stepper-dots')) {
  customElements.define(
    'stepper-dots',
    class StepperDots extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.activeClass = this.getAttribute('active-class');
        this.inactiveClass = this.getAttribute('inactive-class');
        this.pages = this.getAttribute('pages');
      }

      get page() {
        return this.getAttribute('page');
      }

      set page(value) {
        if (typeof Number(value) !== 'number') {
          return;
        }
        if (Number(value) > Number(this.pages) || Number(value) < 1) {
          return;
        }

        const $currentPageDot = this.querySelector(`[data-page="${this.page}"]`);
        $currentPageDot.classList.add(this.inactiveClass);

        const $newPageDot = this.querySelector(`[data-page="${value}"]`);
        $newPageDot.classList.remove(this.inactiveClass);
        $newPageDot.classList.add(this.activeClass);

        this.setAttribute('page', value);
      }
    }
  );
}
